import { render, staticRenderFns } from "./view.html?vue&type=template&id=514cb680&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=514cb680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514cb680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('514cb680')) {
      api.createRecord('514cb680', component.options)
    } else {
      api.reload('514cb680', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=514cb680&scoped=true&", function () {
      api.rerender('514cb680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/award/index.vue"
export default component.exports